import { themeBackgrounds } from "@dana/MobiusOverrides/styles/colors";
import { orderSalespersonStyles } from "@dana/Overrides/Widgets/OrderDetails/OrderSalesperson";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { css } from "styled-components";

orderSalespersonStyles.wrapper = mergeToNew(orderSalespersonStyles.wrapper, {
    width: [12, 12, 12, 12, 12],
    css: css`
        display: flex;
        flex-direction: column;
        padding: 0px;
    `,
});
orderSalespersonStyles.titleText = mergeToNew(orderSalespersonStyles.titleText, {
    variant: "h3",
    css: css`
        margin-bottom: 0px;
        background: ${themeBackgrounds.lightGray};
        padding: 16px;
        width: 100%;
    `,
});
orderSalespersonStyles.orderSalesperson = mergeToNew(orderSalespersonStyles.orderSalesperson, {
    css: css`
        padding: 16px;
    `,
});
